import { InvoiceDebitNoteTypeLabel } from '@/core/domain/invoice/invoice/invoice.enums';
import { Select, SelectProps } from 'antd';

export default function SelectDebitNoteType(props: SelectProps) {
  const options = Object.keys(InvoiceDebitNoteTypeLabel).map((key) => ({
    value: key,
    label:
      InvoiceDebitNoteTypeLabel[
        key as keyof typeof InvoiceDebitNoteTypeLabel
      ],
  }));

  return (
    <Select
      {...props}
      options={options}
      style={{ ...props.style, width: '100%' }}
    />
  );
}
